import React from "react";
import styled, { keyframes } from "styled-components";
import { MinesSelectProps } from "./Mines.types";
import { ChoiceChip, Icon } from "@lindar-joy/goosicorn-quickies-library";

const MinesSelectWrapper = styled.div<Partial<MinesSelectProps>>`
    position: absolute;
    bottom: 134px;
    width: 100%;
    display: flex;
    justify-content: center;
    pointer-events: ${props => props.open ? "initial": "none"};
    z-index: 70;
`;

const MinesSelectContainer = styled.div<Partial<MinesSelectProps>>`
    background-color: var(--primary, rgba(0, 0, 0, 0.95));
    width: 646px;
    border-radius: 16px;
    animation-name: ${props => props.open ? intro: outro};
    animation-fill-mode: forwards;
    animation-duration: 330ms;
    
    @media (max-width: 680px) {
        margin: 0;
        width: 100%;
    }
`;

const intro = keyframes`
    0% { opacity: 0; transform: translateY(100px) }
    100% { opacity: 1; transform: translateY(0px) }
`;

const outro = keyframes`
    0% { opacity: 1; transform: translateY(0px) }
    100% { opacity: 0; transform: translateY(100px) }
`;

const Header = styled.div`
    display: flex;
    height: 56px;
    padding: 8px 16px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    box-sizing: border-box;
    border-bottom: 1px solid var(--neutral-15, rgba(255, 255, 255, 0.15));
`;

const CloseIcon = styled(Icon)<{$disabled: boolean}>`
    float: right;
    margin-left: -16px;
    cursor: pointer;
    pointer-events: ${props => props.$disabled ? "none": "initial"};
`;

const Body = styled.div`
    display: flex;
    padding: 24px 16px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    flex-wrap: wrap;
`;

const MineChip = styled(ChoiceChip)`
    width: 32%;

    @media (max-width: 680px) {
        margin: 0;
        width: 15%;
    }
`;

const MinesSelect: React.FC<MinesSelectProps> = ({
    onCloseRequest,
    onMineSelect,
    mineCount,
    mines,
    ...props
}) => {

    return (
        <MinesSelectWrapper {...props}>
            <MinesSelectContainer {...props}>
                <Header><div style={{ width: "32px" }}></div><div>Number of mines</div> <CloseIcon $disabled={!props.open} type="close" size="md" onClick={ () => onCloseRequest && onCloseRequest() }/></Header>
                <Body>
                    {mines.map((mine, index) => (
                        (
                            <MineChip disabled={!props.open} key={ index } onClick={() => {
                                onMineSelect(mine);
                                onCloseRequest && onCloseRequest();
                            }} content={mine.toString()} selected={mine === mineCount}></MineChip>
                        )
                    ))}
                </Body>
            </MinesSelectContainer>
        </MinesSelectWrapper>
    );
};

export default MinesSelect;